import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import {
	MatDialogRef,
	MatSliderChange,
	MAT_DIALOG_DATA,
} from '@angular/material';
import { finalize, take } from 'rxjs/operators';
import { EventTypes } from '../../../../shared/EventTypes';
import { AppEventDispatcher } from '../../../../utils/AppEventDispatcher';
import { LimiteGlobalService } from '../../limite-global.service';

@Component({
	selector: 'app-modal-ajuste-limite-lg',
	templateUrl: './modal-ajuste-limite-lg.component.html',
	styleUrls: ['./modal-ajuste-limite-lg.component.styl'],
	encapsulation: ViewEncapsulation.None,
})
export class ModalAjusteLimiteLgComponent implements OnInit {
	form: FormGroup;

	valueLimite: number;
	resizing: boolean;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialogRef: MatDialogRef<ModalAjusteLimiteLgComponent>,
		public limiteGlobalService: LimiteGlobalService,
		private formBuilder: FormBuilder
	) {}

	ngOnInit(): void {
		this.valueLimite = this.data.limite || 0;
		this.buildForm();
	}

	private buildForm() {
		this.form = this.formBuilder.group({
			limite: this.valueLimite,
		});
	}

	public get limite(): number {
		return this.form.get('limite').value;
	}

	public get max(): number {
		return (this.data && this.data.max) || 0;
	}

	public get min(): number {
		return (this.data && this.data.min) || 0;
	}

	public onChangeLimite(slide: MatSliderChange): void {
		this.valueLimite = slide.value;
	}

	public onClose(): void {
		this.dialogRef.close();
	}

	public ajusteLimite(): void {
		const { limite } = this.form.getRawValue();
		this.resizing = true;

		this.limiteGlobalService
			.atualizaLimiteCredito(limite)
			.pipe(
				finalize(() => {
					this.resizing = false;
				}),
				take(1)
			)
			.subscribe(
				(res) => {
					if (res && res.Retorno === 'ERROR') {
						this.sendMsgErro(
							res.Mensagem || 'Ocorreu um erro ao solicitar o ajuste de limite.'
						);
						return;
					}
					this.limiteGlobalService.setRefreshLG();
					this.dialogRef.close(limite);
				},
				(error) => {
					this.sendMsgErro(error.error.Mensagem);
				}
			);
	}

	private sendMsgErro(msg: string): void {
		AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, {
			msg,
		});
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/limite-global/components/modal-ajuste-limite-lg/modal-ajuste-limite-lg.component.ts